import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import SavingsBar from '../components/SavingsBar';
import VideoSection from '../components/VideoSection';
import AudienceSection from '../components/AudienceSection';
import Listings from '../components/Listings';
import HomeEstimator from '../components/HomeEstimator';
import SellingProcess from '../components/SellingProcess';
import SavingsCalculator from '../components/SavingsCalculator';
import Features from '../components/Features';
import Testimonials from '../components/Testimonials';
import BlogSection from '../components/BlogSection';
import NewsletterSignup from '../components/NewsletterSignup';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';
import ThreeStepFlow from '../components/ThreeStepFlow';
import WhatsIncluded from '../components/WhatsIncluded';
import ComparisonTable from '../components/ComparisonTable';
import BuyerAgentEducation from '../components/BuyerAgentEducation';
import WhyNotDiscountBroker from '../components/WhyNotDiscountBroker';
import FounderNote from '../components/FounderNote';
import HomeFAQ from '../components/HomeFAQ';
import { AIChatWidget } from '@/components/ui/ai-chat-widget';
import { useIsMobile } from '@/hooks/use-mobile';
import MobileHome from './mobile/MobileHome';

const Index = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileHome />;
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      <div>
        <Hero />
        <SavingsBar />
        <VideoSection />
        <Listings />
        <NewsletterSignup />
        <ThreeStepFlow />
        <WhatsIncluded />
        <ComparisonTable />
        <BuyerAgentEducation />
        <WhyNotDiscountBroker />
        <AudienceSection />
        <HomeEstimator />
        <SellingProcess />
        <SavingsCalculator />
        <Features />
        <FounderNote />
        <Testimonials />
        <HomeFAQ />
        <BlogSection />
        <FinalCTA />
        <Footer />
      </div>
      
      <AIChatWidget
        title="REALV3 Guide"
        badgeText="Community Support"
        quickPrompts={[
          "How does REALV3 work?",
          "How do I list my home?",
          "How do I search for homes?",
        ]}
        edgeFunction="chat"
        placeholder="Questions about buying or selling with REALV3?"
      />
    </div>
  );
};

export default Index;
